import React from 'react'
import {Close, Attachment} from '@mui/icons-material'
import { Box, Button, DialogActions, DialogTitle, IconButton, Stack } from '@mui/material'
import Dialog from '../../../../ui/Modal'
import SourceIDVerificationCard from './SourceIDVerificationCard'

const SourceIdVerificationModal = ({
    open, setOpen, 
    loading, setLoading, 
    handleClose, addNewSourceDocument, 
    sourceFileInfo, setSourceFileInfo, 
    handleSourceFile, handleDeleteCard,
    isAllVerified, onUploadClick
}:any) => {

    return (
    <Dialog
        isOpen={open}
        closeModalClick={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        width="600px"
        height="600px"
    >
        <Stack sx={{p:1}}>
            <div style={{ background: "#EFF4FC" }}>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <div className="modal-title-container" >
                        <span className="text-3E3E3E-20px bold">Upload Document</span>
                        <span className="text-5B5B5B-14px  normal">
                            Please give the necessary information.
                        </span>
                    </div>
                    <IconButton
                        onClick={() => handleClose()}>
                        <Close
                            style={{cursor: "pointer"}}
                        />
                    </IconButton>
                </div>
            </div>
            <Box mt={"20px"} mb={"20px"}>
                <Stack flexDirection={"column"}>
                    <Button 
                        sx={{width:"180px",marginTop: '20px'}}  startIcon={<Attachment color="primary"/>} variant="outlined" 
                        disabled={!isAllVerified}
                        onClick={addNewSourceDocument}>
                        Attach Document
                    </Button>
                </Stack>
            </Box>
            {
            <Stack>
                {sourceFileInfo && sourceFileInfo
                .map((item: any, index: number) => (
                    <SourceIDVerificationCard 
                        key={index} 
                        index={index}
                        item={item}
                        loading={loading}
                        setLoading={setLoading}
                        handleSourceFile={handleSourceFile}
                        handleDeleteCard={handleDeleteCard}
                    />	
                ))}
            </Stack>
            }
            <DialogActions>
                <Stack
                    style={{ marginTop: "24px" }}
                    direction={"row"}
                    spacing={1}
                    justifyContent="flex-end"
                >
                    <Button onClick={handleClose} variant="outlined">
                        Cancel
                    </Button>
                    <Button variant="contained" disabled={!isAllVerified} onClick={onUploadClick}>
                        Upload
                    </Button>
                </Stack>
            </DialogActions>
        </Stack>
    </Dialog>
  )
}

export default SourceIdVerificationModal